import { ReturnAmounts } from '@/ui/components/analytics-components'
import { useRegisterChatContext } from '@/ui/components/ai-chat'
import { useTranslation } from 'react-i18next'
import { useReturnRateAnalyticsAllowed } from '@/hooks/use-scope-platform'
import { NavigationTabs, TabProps } from '@/ui/shared'
import { AnalyticsFilterBar } from '@/ui/components/analytics-filters'
import { DateRangePicker, useAnalyticsDateRange } from '@/ui/shared/date-range'

function ProductAnalytics() {
  const isReturnAnalyticsAllowed = useReturnRateAnalyticsAllowed()

  const { t } = useTranslation()

  useRegisterChatContext({
    tab: 'analytics',
    getPayload: () => ({ current_tab: 'analytics' })
  })

  const tabs: TabProps[] = [
    {
      copy: t('product_analytics.return_amount'),
      link: '/analytics/products'
    },
    {
      copy: t('product_analytics.return_rate'),
      link: '/analytics/products-return-rates'
    }
  ]

  const { fromDate, toDate, range, setRange } = useAnalyticsDateRange()

  return (
    <>
      {isReturnAnalyticsAllowed ? (
        <NavigationTabs tabs={tabs} selectedIndex={0} />
      ) : null}
      <div className="flex h-full flex-col items-center overflow-scroll [&::-webkit-scrollbar]:hidden">
        <div className="flex w-full max-w-[1000px] items-center justify-between px-4 pt-4">
          <AnalyticsFilterBar startDate={fromDate} endDate={toDate} />
          <div className="w-60">
            <DateRangePicker selected={range} onSelect={setRange} />
          </div>
        </div>

        <ReturnAmounts fromDate={fromDate} toDate={toDate} />
      </div>
    </>
  )
}

export default ProductAnalytics
